<script setup lang="ts">
defineProps<{
  type: 'artikel-panduan' | 'video-panduan'
}>()
</script>

<template>
  <Card class="mt-6 p-0">
    <div class="flex flex-col items-center justify-center py-8 sm:py-12 px-4 text-center gap-2">
      <div class="inline-flex items-center px-6 sm:px-8 py-2 sm:py-3 rounded-full border border-neutral-300 bg-gradient-putih shadow-sm">
        <span class="font-bold text-neutral-800 text-sm sm:text-base">Coming Soon</span>
      </div>

      <h2 class="text-xl sm:text-3xl font-bold text-neutral-800 px-2">
        {{ type === 'artikel-panduan' ? 'Artikel panduan sedang disiapkan' : 'Video panduan sedang disiapkan' }}
      </h2>

      <p class="text-sm sm:text-base text-neutral-800 max-w-sm sm:max-w-none px-2">
        {{ type === 'artikel-panduan'
          ? 'Sebentar lagi, panduan penggunaan Rintisan Billing dalam bentuk artikel dapat kamu akses. Tungguin, ya!'
          : 'Sebentar lagi, panduan penggunaan Rintisan Billing dalam bentuk video dapat kamu akses. Tungguin, ya!' }}
      </p>

      <img
        :src="type === 'artikel-panduan' ? '/img/help-center/comingsoon_article.webp' : '/img/help-center/comingsoon_video.webp'"
        :alt="type === 'artikel-panduan' ? 'Artikel panduan coming soon' : 'Video panduan coming soon'"
        class="w-auto h-24 sm:h-36 object-contain"
      >
    </div>
  </Card>
</template>
